"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvVarIfValid = exports.getUrlFromEnv = exports.getBooleanFromEnv = exports.isTestEnv = exports.getNumberFromEnv = exports.initEnv = void 0;
const tslib_1 = require("tslib");
const assert_1 = tslib_1.__importDefault(require("assert"));
const dotenv_1 = tslib_1.__importDefault(require("dotenv"));
const lodash_1 = tslib_1.__importDefault(require("lodash"));
function initEnv() {
    if (process.env.CONFIG_PATH) {
        dotenv_1.default.config({ path: process.env.CONFIG_PATH });
    }
    else {
        dotenv_1.default.config();
    }
}
exports.initEnv = initEnv;
function getNumberFromEnv(name, defaultValue) {
    const res = getEnvVarIfValid(name, defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.toString());
    const num = parseInt(res, 10);
    assert_1.default(!lodash_1.default.isNaN(res), `${name} environment variable is not a number`);
    return num;
}
exports.getNumberFromEnv = getNumberFromEnv;
function isTestEnv() {
    if (getBooleanFromEnv("ACUMEN_TEST_ENV", false)) {
        // tslint:disable-next-line: no-console
        console.log(`Acumen running in test mode, reason: ACUMEN_TEST_ENV=${process.env.ACUMEN_TEST_ENV}`);
        return true;
    }
    // NOTE: Check if mocha is loaded
    if (typeof global.it === "function") {
        return true;
    }
    return false;
}
exports.isTestEnv = isTestEnv;
function getBooleanFromEnv(name, defaultValue) {
    return getEnvVarIfValid(name, defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.toString().toLowerCase()) === "true";
}
exports.getBooleanFromEnv = getBooleanFromEnv;
function getUrlFromEnv(name, defaultValue) {
    const res = getEnvVarIfValid(name, defaultValue);
    const resUrl = new URL(res);
    if (resUrl === undefined) {
        throw new Error(`Environment variable ${name} is not a valid url: ${res}`);
    }
    return res;
}
exports.getUrlFromEnv = getUrlFromEnv;
function getEnvVarIfValid(name, defaultValue) {
    const res = process.env[name];
    if (!res) {
        if (defaultValue === undefined) {
            throw new Error(`Environment variable ${name} is empty or undefined.`);
        }
        return defaultValue;
    }
    return res;
}
exports.getEnvVarIfValid = getEnvVarIfValid;
//# sourceMappingURL=env.js.map